import { PTableHead, PTableHeadCell, PTableHeadRow } from "@porsche-design-system/components-react"
import { FormattedMessage } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { offerListMessages } from "./offerList.messages"

export const OfferListTableHead = () => {
	return (
		<PTableHead>
			<PTableHeadRow>
				<PTableHeadCell>
					<FormattedMessage {...commonMessages.businessPartnerId} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...offerListMessages.salesperson} />
				</PTableHeadCell>
				<PTableHeadCell
					sort={{
						active: true,
						direction: "desc",
						id: "creationDate",
					}}
				>
					<FormattedMessage {...offerListMessages.creationDate} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...offerListMessages.offerCode} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...commonMessages.customerType} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...offerListMessages.tradeIn} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...offerListMessages.price} />
				</PTableHeadCell>
			</PTableHeadRow>
		</PTableHead>
	)
}
